module.exports = __webpack_public_path__ + "images/category_lp/retro_game/assessment_achievements/1_dc966cce0e97a3fc445797622bb29288.png";